import { UploadOutlined } from '@ant-design/icons';
import { Avatar, Col, Row, Upload } from 'antd';
import { observer } from 'mobx-react';
import { useState } from 'react';
import styled from 'styled-components';

import { webServiceProvider } from 'shared';
import AppStore from 'stores/App';
import ShopStore from 'stores/ShopStore';

const { Dragger } = Upload;

const StyledAvatar = styled(Avatar)`
  &&& {
    width: 100%;
    height: 200px;
    margin: auto;
    border: 1px solid #d9d9d9;
    background: #fafafa;

    span {
      width: 100%;
      height: 100%;
    }

    img {
      max-width: 100%;
      max-height: 100%;
      object-fit: scale-down;
    }
  }
`;

const EditImageForm = () => {
  const [fileList, setFileList] = useState([]);
  const defaultShopLogoUrl =
    'https://dashboard-campaign.s3.us-east-2.amazonaws.com/plogo.svg';

  const beforeFileUpload = (file) => {
    setFileList([file]);
    onDrop(file);
    return false;
  };

  const onDrop = async (file) => {
    const fd = new FormData();
    fd.append('singleInputFileName', file);

    try {
      AppStore.addLoading('Uploading image...');

      const data = await webServiceProvider.postFormData(
        `dashboard/v1/uploadShopImage?shopId=${ShopStore.currentShop.id}`,
        fd
      );

      AppStore.addSuccess(`Image ${file.name} uploaded successfully!`);
      ShopStore.data.get(ShopStore.currentShop.id).logoUrl = data.fileUrl;
      ShopStore.currentShop.logoUrl = data.fileUrl;
    } catch (e) {
      AppStore.addError(`Image ${file.name} upload failed!`);
    } finally {
      AppStore.removeLoading('Uploading image...');
    }
  };

  const removeFile = () => {
    setFileList([]);
    ShopStore.currentShop.logoUrl = '';
  };

  let shopLogo = ShopStore.currentShop.logoUrl || defaultShopLogoUrl;

  return (
    <>
      <Row gutter={[0, 16]}>
        <Col span={24}>
          <Dragger
            showUploadList={false}
            beforeUpload={beforeFileUpload}
            fileList={fileList}
            onRemove={removeFile}
          >
            <p className="ant-upload-drag-icon">
              <UploadOutlined />
            </p>
            <p className="ant-upload-text">
              Click or drag file to this area to upload
            </p>
          </Dragger>
        </Col>

        <Col span={24}>
          {ShopStore.currentShop.logoUrl && (
            <StyledAvatar shape="square" alt="example" src={shopLogo} />
          )}
        </Col>
      </Row>
    </>
  );
};

export default observer(EditImageForm);
